import React, { ReactElement } from 'react';
import { Connections } from '../../../components';
import { ConnectedSessionNodes } from '../../../components/Nodes/container';
import { useCanvas } from '../../../hooks/use-canvas';
import { DiagramLines } from '../../../components/DiagramLines';
import { BoxSelectors } from '../../../components/BoxSelectors';
import { getBoxNodesFromNodes } from '../../utils';
import styles from './SessionDiagram.module.css';

interface SessionDiagramProps {
  connections: DiagramConnection[];
  nodes: DiagramNodeTypes[];
}

export function SessionDiagram({
  connections,
  nodes,
}: SessionDiagramProps): ReactElement {
  const { canvasRef } = useCanvas();

  return (
    <div className={styles.root}>
      <div id="canvas" className={styles.board} ref={canvasRef}>
        <svg preserveAspectRatio="xMidYMid meet" className={styles.svg}>
          <DiagramLines nodes={nodes} />
          <Connections connections={connections} />
          <BoxSelectors
            boxes={getBoxNodesFromNodes(nodes)}
            isSessionView={true}
          />
        </svg>
        <ConnectedSessionNodes />
      </div>
    </div>
  );
}
